import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

const currentLocale = navigator.language.toLowerCase();
const locales = import.meta.glob('../node_modules/dayjs/esm/locale/*.js', {});

const getUrl = (locale: string) =>
  `../node_modules/dayjs/esm/locale/${locale}.js`;

(async () => {
  if (getUrl(currentLocale) in locales) {
    await locales[getUrl(currentLocale)]();
    dayjs.locale(currentLocale);
  }
})();
